enum Params {
  keyword = "{{keyword}}",
  eventid = "{{eventid}}",
  memberid = "{{memberid}}",
  participantid = "{{participantid}}",
  responseid = "{{responseid}}",
  email = "{{email}}",
}

class API {
  /**
   * @description 取得會議狀態
   */
  public static GetEventStatus = {
    Descption: "取得會議狀態",
    Path: "/event-status/1",
    MockRegExp: "/mock/event-status/1",
    Params: {},
  };

  /**
   * @description 取得 response 狀態
   */
  public static GetResponseStatus = {
    Descption: "取得 response 狀態",
    Path: "/event-status/2",
    MockRegExp: "/mock/event-status/2",
    Params: {},
  };

  /**
   * @description 取得會議地點
   */
  public static GetLocations = {
    Descption: "取得會議地點",
    Path: "/dp/event-locations",
    MockRegExp: "/mock/dp/locations",
    Params: {},
  };

  /**
   * @description 傳入關鍵字取得 user
   */
  public static SearchUserByKeyword = {
    Descption: "傳入關鍵字取得 user",
    Path: "/members/search/{{keyword}}",
    MockRegExp: RegExp(/^\/mock\/members\/search\/[\@\.a-zA-Z0-9-]*/),
    Params: {
      keyword: Params.keyword,
    },
  };

  /**
   * @description 指定事件, 取得內容
   */
  public static GetEvent = {
    Descption: "指定事件, 取得內容",
    Path: "/event-headers/{{eventid}}",
    MockRegExp: RegExp(
      /^\/mock\/event-headers\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      eventid: Params.eventid,
    },
  };

  /**
   * @description 指定事件, 取得所有投票選項
   */
  public static GetEventSchedulars = {
    Descption: "指定事件, 取得所有投票選項",
    Path: "/event-headers/{{eventid}}/event-schedules",
    MockRegExp: RegExp(
      /^\/mock\/event-headers\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/event-schedules$/
    ),
    Params: {
      eventid: Params.eventid,
    },
  };

  /**
   * @description 指定事件, 取得所有人員
   */
  public static GetEventParticipants = {
    Descption: "指定事件, 取得所有人員",
    Path: "/event-headers/{{eventid}}/event-participants",
    MockRegExp: RegExp(
      /^\/mock\/event-headers\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/event-participants$/
    ),
    Params: {
      eventid: Params.eventid,
    },
  };

  /**
   * @description 指定事件, 取得所有user投票結果
   */
  public static GetEventResponses = {
    Descption: "指定事件, 取得所有user投票結果",
    Path: "/dp/event-participants/1/event-responses/{{eventid}}",
    MockRegExp: RegExp(
      /^\/mock\/dp\/event-participants\/1\/event-responses\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      eventid: Params.eventid,
    },
  };
  /**
   * @description 指定人員 取得 主持 的所有事件
   */
  public static GetRecordEvents = {
    Descption: "指定人員 取得 會議 的所有事件",
    Path: "/dp/members/{{memberid}}/3",
    MockRegExp: RegExp(
      /^\/mock\/dp\/members\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/1$/
    ),
    Params: {
      memberid: Params.memberid,
    },
  };
  /**
   * @description 指定人員 取得 主持 的所有事件
   */
  public static GetHosterEvents = {
    Descption: "指定人員 取得 主持 的所有事件",
    Path: "/dp/members/{{memberid}}/1",
    MockRegExp: RegExp(
      /^\/mock\/dp\/members\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/1$/
    ),
    Params: {
      memberid: Params.memberid,
    },
  };

  /**
   * @description 指定人員 取得 參與 的所有事件
   */
  public static GetParticipantEvents = {
    Descption: "指定人員 取得 參與 的所有事件",
    Path: "/dp/members/{{memberid}}/2",
    MockRegExp: RegExp(
      /^\/mock\/dp\/members\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/2$/
    ),
    Params: {
      memberid: Params.memberid,
    },
  };

  /**
   * @description 指定人員, 取得所有參與事件投票選項
   */
  public static GetAllParticipantEventSchedularByUser = {
    Descption: "指定人員，取得所有參與事件投票選項",
    Path: "/dp/event-headers/{{memberid}}/event-schedules",
    MockRegExp: RegExp(
      /^\/mock\/dp\/event-headers\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/event-schedules$/
    ),
    Params: {
      memberid: Params.memberid,
    },
  };

  /**
   * @description 指定人員, 取得所有參與事件投票結果
   */
  public static GetAllParticipantEventResponseByUser = {
    Descption: "指定人員, 取得 所有參與事件投票結果",
    Path: "/dp/event-participants/2/event-responses/{{memberid}}",
    MockRegExp: RegExp(
      /^\/mock\/dp\/event-participants\/2\/event-responses\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      memberid: Params.memberid,
    },
  };

  /**
   * @description 指定事件、人員，取得該事件各時間選項的統計結果和該人員是否同意
   */
  public static GetEventSchedularSummaryByUser = {
    Descption: "指定事件、人員，取得該事件各時間選項的統計結果和該人員是否同意",
    Path: "/dp/event-schedules/{{eventid}}/response/{{memberid}}",
    MockRegExp: RegExp(
      /^\/mock\/dp\/event-schedules\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/response\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      eventid: Params.eventid,
      memberid: Params.memberid,
    },
  };

  /**
   * @description 新增事件
   */
  public static PostNewEvent = {
    Descption: "新增事件",
    Path: "/event-headers/member/{{memberid}}",
    MockRegExp: RegExp(
      /^\/mock\/event-headers\/member\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      memberid: Params.memberid,
    },
  };

  /**
   * @description 新增事件時間選項 (多筆)
   */
  public static PostNewEventSchedulars = {
    Descption: "新增事件時間選項 (多筆)",
    Path: "/event-schedules/{{eventid}}/collection",
    MockRegExp: RegExp(
      /^\/mock\/event-schedules\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/collection$/
    ),
    Params: {
      eventid: Params.eventid,
    },
  };

  /**
   * @description 新增user的事件單一response
   */
  public static PostNewEventResponse = {
    Descption: "新增user的事件單一response",
    Path: "/participant-responses/{{eventid}}",
    MockRegExp: RegExp(
      /^\/mock\/participant-responses\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      eventid: Params.eventid,
    },
  };

  /**
   * @description 修改事件
   */
  public static PutEvent = {
    Descption: "修改事件",
    Path: "/event-headers/{{eventid}}",
    MockRegExp: RegExp(
      /^\/mock\/event-headers\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      eventid: Params.eventid,
    },
  };

  /**
   * @description 進行寄信
   */
  public static SendMail = {
    Descption: "進行寄信",
    Path: "/event-headers/{{eventid}}/sendmail",
    MockRegExp: RegExp(
      /^\/mock\/event-headers\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      eventid: Params.eventid,
    },
  };

  /**
   * @description 建置事件人員
   */
  public static PutEventParticipants = {
    Descption: "建置事件人員",
    Path: "/event-participants/{{eventid}}/collection",
    MockRegExp: RegExp(
      /^\/mock\/event-participants\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/collection$/
    ),
    Params: {
      eventid: Params.eventid,
    },
  };

  /**
   * @description 更新user的事件單一response
   */
  public static PutEventResponse = {
    Descption: "更新user的事件單一response",
    Path: "/participant-responses/{{responseid}}",
    MockRegExp: RegExp(
      /^\/mock\/participant-responses\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      responseid: Params.responseid,
    },
  };

  /**
   * @description 更新user的事件單一response
   */
  public static PutEventResponseNone = {
    Descption: "修改事件單一人員 (改為時段皆否)",
    Path: "/event-participants/{{participantid}}",
    MockRegExp: RegExp(
      /^\/mock\/event-participants\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      participantid: Params.participantid,
    },
  };

  /**
   * @description 登入後取得 Memeber Id
   */
  public static SSOuser = {
    Descption: "登入後取得 Memeber Id",
    Path: "/members/login",
    MockRegExp: RegExp(/^\/mock\/members\/login/),
    Params: {
      email: Params.email,
    },
  };

  /**
   * @description 指定事件, 取得所有人員
   */
  public static GetEventParticipantStatus = {
    Descption: "取得事件單一參與人員狀態",
    Path: "/event-participants/{{participantid}}",
    MockRegExp: RegExp(
      /^\/mock\/event-participants\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    ),
    Params: {
      participantid: Params.participantid,
    },
  };
}

export default API;
